import { marxy } from '../initMarxy'
import { safeMarxyCall } from '../helpers'
import { MarxyEvents } from '~/utils/marxy/types'

/**
 * Tracks a page visit
 *
 * IMPORTANT
 * This function is private, it is called after the page load (see eventTracking.js)
 * and is NOT connected to the Marxy SDK (window.marxy.eventTracking)
 * Never call this function directly. This would wrap the function in a bad JS chunk,
 * duplicate the initialization of the Marxy SDK, and possibly incorrect behaviour.
 */
const trackPageVisit = () => {
  safeMarxyCall(() => {
    marxy.trackEvent(MarxyEvents.PAGE_VISIT)
  })
}

export default trackPageVisit
